import { cn } from '@kidshome/ui';

/**
 * The effort-star (✨) glyph as a crisp inline SVG — the PLAIN, un-skinned star used wherever the ✨
 * currency is shown to a GUARDIAN (oversight balances, member cards). The kid's own ✨ surfaces are
 * hero-skinned (ADR-0103, see `entities/hero/hero-currency`); this is deliberately the canonical star.
 *
 * Inherits `currentColor` (so it tints with the violet {@link StarChip} or any wrapping color) and sizes
 * to `1em`, scaling with the font-size of its context with no props — mirrors {@link CoinIcon}.
 */
export function StarIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('inline-block size-[1.1em] shrink-0 align-[-0.15em]', className)}
    >
      <path
        d="M12 2.6l2.6 6.5 7 .5-5.4 4.5 1.7 6.8L12 17.7 6.1 21.4l1.7-6.8L2.4 9.6l7-.5z"
        fill="currentColor"
      />
    </svg>
  );
}
